import { forwardRef } from "react";
const SvgCaretDown = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M8.70708 10.2929L11.2929 7.70711C11.9228 7.07714 11.4767 6 10.5858 6L5.41419 6C4.52329 6 4.07712 7.07714 4.70708 7.7071L7.29287 10.2929C7.68339 10.6834 8.31656 10.6834 8.70708 10.2929Z" fill="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgCaretDown);
export default ForwardRef;